import type { ReactNode } from "react";
import { Header } from "@/app/layouts/Header";
import { MainContent } from "@/app/layouts/layoutAccessibility";
import { SideMenu } from "@/app/layouts/SideMenu";
import { useSideMenu } from "@/app/layouts/SideMenuContext";

interface Props {
  children: ReactNode;
}

export const MobileLayout: React.FunctionComponent<Props> = ({
  children,
}: Props) => {
  const { isSideMenuOpen, closeSideMenu } = useSideMenu();

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header />

      {/* メインコンテンツ */}
      <MainContent className="flex-1 min-h-0 flex flex-col overflow-hidden pl-[env(safe-area-inset-left)] pr-[env(safe-area-inset-right)] pb-[env(safe-area-inset-bottom)]">
        {children}
      </MainContent>

      {/* モーダル */}
      <SideMenu isOpen={isSideMenuOpen} onClose={closeSideMenu} />
    </div>
  );
};
